/* c8 ignore start */
import { useEffect } from "react";

export const useAutoShowActionBar = (props, actionBarRef, setHideBar) => {
  const { autoHideTime, isFullScreen } = props;
  /* c8 ignore next 24 */
  useEffect(() => {
    const handleMouseMove = () => {
      if (isFullScreen && autoHideTime) {
        setHideBar(false);
        clearTimeout(actionBarRef.current);
        actionBarRef.current = setTimeout(() => {
          setHideBar(true);
        }, autoHideTime);
      }
    };
    document?.addEventListener("mousemove", handleMouseMove);
    return () => {
      document?.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(actionBarRef.current);
    };
  }, [isFullScreen, autoHideTime]); //eslint-disable-line
};
/* c8 ignore stop */
